module.exports = __webpack_public_path__ + "static/img/bg_en.f6408a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bfSaled-2025/bg_en.png
// module id = 8ao5
// module chunks = 1